import { withScope } from '@/contexts/ScopeContext';
import Button from '@/se/components/Button[DEPRECATED]';
import ErrorFactory from '@/se/components/errors/Error';
import { withLabel } from '@/se/components/Label';
import { gql, useQuery } from '@apollo/client';
import { Mutation } from '@apollo/client/react/components';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import React, { Fragment, useState } from 'react';
import { a11yProps, TabPanel } from '../core/TabPanel';
import { OrganizationType } from '../entities/hospitals/enums';
import InstructionsEditor from '../entities/InstructionsEditor/InstructionsEditor';
import CustomMessageTemplate from '../entities/notificationTemplate/CustomMessageTemplate';

import NotificationTemplates from '../entities/notificationTemplate/NotificationTemplates';
import PatientNameFormatInput from '../inputs/PatientNameFormatInput';

const PatientNameFormatInputWithLabel = withLabel(
  'Patient Name Format',
  {},
  'This is how the patient name is displayed on the mobile patient journey page sent to the caretaker.'
)(PatientNameFormatInput);

const Error = ErrorFactory();

export const SectionTitle = props => (
  <Typography variant="h4" style={{ fontSize: '2rem', marginTop: '1em', marginBottom: 0 }} {...props} />
);

export const SectionTitle2 = props => (
  <Typography
    variant="h4"
    style={{ fontSize: '2rem', marginTop: '1em', marginBottom: 0, marginLeft: '2rem' }}
    {...props}
  />
);

const familyMemberPagePatientNameFormat = gql`
  query familyMemberPagePatientNameFormat {
    familyMemberPagePatientNameFormat
  }
`;

const setFamilyMemberPagePatientNameFormat = gql`
  mutation setFamilyMemberPagePatientNameFormat($patientNameFormat: PatientNameFormat!) {
    setFamilyMemberPagePatientNameFormat(patientNameFormat: $patientNameFormat)
  }
`;

const FamilyMemberPage = () => {
  const [state, setState] = useState();
  const { data } = useQuery(familyMemberPagePatientNameFormat);
  const patientNameFormat = state || get(data, 'familyMemberPagePatientNameFormat') || 'InitialsOnly';
  const isChanged = patientNameFormat !== get(data, 'familyMemberPagePatientNameFormat');

  const onComplete = () => console.log('completed');

  const handleSubmit = mutation => e => {
    e.preventDefault();

    mutation({
      variables: {
        patientNameFormat,
      },
      refetchQueries: [{ query: familyMemberPagePatientNameFormat }],
    });
  };

  return (
    <Fragment>
      <Typography variant="h1">Patient Status Page</Typography>
      <Mutation mutation={setFamilyMemberPagePatientNameFormat} onComplete={onComplete}>
        {(mutation, { loading, error }) => (
          <Box mt={8}>
            <form onSubmit={handleSubmit(mutation)}>
              <PatientNameFormatInputWithLabel
                value={patientNameFormat}
                onChange={setState}
                isClearable={false}
                isSearchable={false}
              />
              {isChanged && (
                <Button primary disabled={loading}>
                  Save
                </Button>
              )}
              <Error isVisible={error !== undefined} id={`FamilyMemberPage-PatientNameFormat`}>
                <p>An unexpected error has occurred. Please, try again or contact our support.</p>
              </Error>
            </form>
          </Box>
        )}
      </Mutation>
    </Fragment>
  );
};

export default withScope(({ scope }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isExchangeOnly = get(scope, 'hospital.exchangeOnly', false);
  const isSC = get(scope, 'hospital.type') === OrganizationType.SurgeryCenter;

  return (
    <div>
      {isSC ? (
        <Fragment>
          <Tabs indicatorColor={'primary'} value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Patient Messaging" {...a11yProps(0)} />
            <Tab label="Caretaker Messaging" {...a11yProps(1)} />
            <Tab label="Staff Messaging" {...a11yProps(2)} />
            <Tab label="Surgical Instructions" {...a11yProps(3)} />
            <Tab label="Custom Messaging" {...a11yProps(4)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <NotificationTemplates destinations={[{ title: 'Patient Messaging', keys: ['Patient', 'Procedure'] }]} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <FamilyMemberPage />
            <NotificationTemplates destinations={[{ title: 'Caretaker Messaging', keys: ['Caretaker'] }]} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <NotificationTemplates
              destinations={[
                {
                  title: 'Staff Messaging',
                  keys: ['Physician', 'StaffMember', 'Anesthesiologist', 'HiringManager', 'Vendor'],
                },
              ]}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <InstructionsEditor />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <CustomMessageTemplate destinations={[{ title: 'Custom Messaging', keys: ['Caretaker', 'Patient'] }]} />
          </TabPanel>
        </Fragment>
      ) : isExchangeOnly ? (
        <Fragment>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor={'primary'}>
            <Tab label="Physicians Messaging" {...a11yProps(0)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <NotificationTemplates destinations={[{ title: 'Physician Messaging', keys: ['Physician'] }]} />
          </TabPanel>
        </Fragment>
      ) : (
        <Fragment>
          <Tabs indicatorColor={'primary'} value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Patient Messaging" {...a11yProps(0)} />
            <Tab label="Physicians Messaging" {...a11yProps(1)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <NotificationTemplates destinations={[{ title: 'Patient Messaging', keys: ['Patient', 'Procedure'] }]} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <NotificationTemplates destinations={[{ title: 'Physician Messaging', keys: ['Physician'] }]} />
          </TabPanel>
        </Fragment>
      )}
    </div>
  );
});
